import { useState } from 'react';
import { Button, Confirm, useNotify, useRecordContext } from 'react-admin';

const FetchButton = ({
  type,
  label = "Update",
  variant = "contained",
  confirmTitle = "Confirm fetch",
  confirmMessage = "Fetch new data for all store records?",
  requireConfirm = false,
}) => {
  const record = useRecordContext();
  const notify = useNotify();
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleFetch = async () => {
    let successMessage = "";
    let body = {};

    switch (type) {
      case 'single':
        body.id = record?.id;
        successMessage = `Triggered update for store ${record?.id}`;
        break;
      case 'new':
        body.id = 0;
        successMessage = 'Triggered update for all new store records.';
        break;
      default:
        break;
    }

    try {
      const response = await fetch('https://f7abvvodv3v4lushbdzogngode0urhli.lambda-url.us-east-1.on.aws/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body), 
      });

      if (!response.ok) throw new Error('Fetch failed');
      notify(successMessage);
    } catch (error) {
      console.error(error);
      notify('Error triggering update. Check console for details.');
    }
  };

  const handleClick = (e) => {
    e.stopPropagation();

    if (requireConfirm) {
      setConfirmOpen(true);
      return;
    }

    handleFetch();
  };

  const handleConfirm = () => {
    setConfirmOpen(false);
    handleFetch();
  };

  const handleClose = () => {
    setConfirmOpen(false);
    notify("Fetch canceled.", { type: "info" });
  };

  return (
    <>
      <Button
        variant={variant}
        onClick={handleClick}
        sx={{ paddingRight: 0 }}
      >
        {label}
      </Button>

      {requireConfirm ? (
        <Confirm
          isOpen={confirmOpen}
          title={confirmTitle}
          content={confirmMessage}
          onConfirm={handleConfirm}
          onClose={handleClose}
        />
      ) : null}
    </>
  )
};

export default FetchButton;
